import PureRenderMixin from 'react-addons-pure-render-mixin';
import React from 'react';
import styled from 'styled-components';

import CircleIcon from './icons/circle_icon';
import TransferFillIcon from 'components/common/icons/fill/transfer-fill';

export default class TransferButton extends React.Component {
  constructor(props) {
    super(props);
    this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
  }
  render() {
    return (
      <CircleIcon viewBox="0 0 25 25" {...this.props}>
        <StyledTransferIcon />
      </CircleIcon>
    );
  }
}

const StyledTransferIcon = styled(TransferFillIcon)`
  path {
    transform: scale(0.6);
    transform-origin: center;
  }
`;
